// 先导入并初始化 NativeModules，确保它在模块加载时就可用了
import CustomNativeModules from './native-modules';
import TurboModuleRegistry from './turbo-module';

// 然后导出 react-native-web 的所有内容
export * from 'react-native-web';

// 兼容 requireNativeComponent 调用（返回一个简单的占位组件）
export const requireNativeComponent = (name: string) => {
  const React = require('react');
  const { View } = require('react-native-web');
  const Component = (props: any) => React.createElement(View, props);
  Component.displayName = `RNWStub(${name})`;
  return Component;
};

// 导出自定义的 NativeModules（覆盖 react-native-web 的版本）
export const NativeModules = CustomNativeModules;

// 导出 TurboModuleRegistry（react-native-web 没有这个）
export { TurboModuleRegistry };
export { TurboModuleRegistry as default } from './turbo-module';

// 兼容 PermissionsAndroid（Web 不支持，提供空实现以避免构建失败）
export const PermissionsAndroid = {
  request: async () => 'granted',
  RESULTS: { GRANTED: 'granted' },
  PERMISSIONS: {
    POST_NOTIFICATIONS: 'android.permission.POST_NOTIFICATIONS',
    CAMERA: 'android.permission.CAMERA',
    RECORD_AUDIO: 'android.permission.RECORD_AUDIO',
    READ_EXTERNAL_STORAGE: 'android.permission.READ_EXTERNAL_STORAGE',
    WRITE_EXTERNAL_STORAGE: 'android.permission.WRITE_EXTERNAL_STORAGE',
  },
};

// 兼容 NativeAppEventEmitter（用 DeviceEventEmitter 代替或空实现）
export const NativeAppEventEmitter = {
  addListener: () => ({ remove: () => {} }),
  removeListener: () => {},
};

